
import * as React from 'react';

interface PeopleDetail {
  name: string;
  designation: string;
  image: string;
}

export interface PeopleState {
  peoples: PeopleDetail[];
}

class People extends React.PureComponent<{}, PeopleState> {

  constructor(props: React.ReactPropTypes) {
    super(props);

    this.state = {
      peoples: [
        {
          name: 'Nurima Ribeiro Alkatiri',
          designation: 'Board President',
          image: 'assets/images/people/nurima.jpg',
        },
        {
          name: 'Sarah Assis',
          designation: 'General Manager',
          image: 'assets/images/people/sarah.jpg',
        },
        {
          name: 'Simone B. Assis',
          designation: 'Our Founder and Executive Director',
          image: 'assets/images/people/simone-assis.jpg',
        },
        {
          name: 'Nelia Marcal',
          designation: 'Finance Manager',
          image: 'assets/images/people/nelia.jpg',
        }
      ]
    };
  }

  render(): JSX.Element {
    return (

      <section id="volunteer-section" className="volunteer-section">
        <div className="volunteer-header">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-sm-12 col-xs-12">
                <h2 className="lg-title text-center">
                  <span>Our People</span>
                </h2>
              </div>
              {/*/.col*/}
              <div className="col-md-6 col-sm-12 col-xs-12 col-md-offset-3">
                <p className="lg-text text-center">These are some of the people that make the difference in changing the lives of many young adolescent women in Timor-Leste</p>
              </div>
              {/*/.col*/}
            </div>
          </div>
        </div>

        <div className="volunteers pad-b-80">
          <div className="container">
            <div className="row">

              {
                this.state.peoples.map((people) => {
                  return <div key={people.name} className="col-md-3 col-sm-6 col-xs-12">
                    <div className="team-wrap text-center">
                      <div className="team-img">
                        <img className="img-responsive" src={people.image} alt="team-avatar" />
                        <div className="team-social">
                          <a href="https://www.instagram.com/proema.timorleste/">
                            <i className="fa fa-instagram" />
                          </a>
                          <a href="https://www.facebook.com/proema.timorleste/">
                            <i className="fa fa-facebook" />
                          </a>
                          <a href="https://www.tripadvisor.com.br/Restaurant_Review-g297517-d14001055-Reviews-Pro_Ema_Restaurant_School-Dili_Dili_District.html">
                            <i className="fa fa-tripadvisor" />
                          </a>
                        </div>
                      </div>
                      <div className="team-content">
                        <h4>{people.name}</h4>
                        <span className="designation">{people.designation}</span>
                      </div>
                    </div>
                  </div>;
                })
              }
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default People;



// WEBPACK FOOTER //
// ./src/components/People.tsx